import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { useAuthStore } from "@/store/authStore";
// Initialise i18n on module load — sets up English baseline + es/pt locales,
// detects browser language, persists user choice in localStorage.
import "@/lib/i18n";

/**
 * App root. One responsibility beyond the router:
 *
 *   Bootstrap the auth state ONCE on first paint. Previously this only
 *   happened inside UserPill, which meant routes that don't render a
 *   pill (/account, /leagues, /admin, /league/:code) hung in
 *   `status === "unknown"` and showed perpetual loading spinners.
 *   Hoisting it here means every page sees real auth state immediately.
 *
 * (The PWA service worker was removed May 24, 2026 — no SW means no
 * update-prompt banner mounted here anymore. Cache freshness is handled
 * by HTTP Cache-Control headers configured via client/public/serve.json.)
 */
export function App() {
  const loadMe = useAuthStore((s) => s.loadMe);
  useEffect(() => {
    void loadMe();
  }, [loadMe]);

  return <RouterProvider router={router} />;
}
